import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import RadioGroup from '../../form/radio-group';
import dayjs from 'dayjs';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { filter: null };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.profile != this.props.profile) {
            return true;
        }

        if (nextProps.profiles != this.props.profiles) {
            return true;
        }

        if (nextProps.tab != this.props.tab) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextState.filter != this.state.filter) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.tab == 'friend'
            &&
            prevProps.profiles
            &&
            prevProps.profiles.length == 2
            &&
            this.props.tab == 'friend'
            &&
            this.props.profiles.length == 1
        ) {
            this.props.userUpdate({
                tab: 'you',
                selected_profile: this.props.profiles[0],
            });
        }
    }

    render({ mode, tab, profiles, logged_in, submitting }) {
        if (logged_in && !submitting) {
            if (tab == 'friend' && profiles && profiles.length > 1) {
                return (
                    <profiles-list mode={mode}>
                        {this.renderSearch()}
                        {this.renderProfiles()}
                    </profiles-list>
                );
            }

            return (<profiles-list mode={mode} />);
        }

        return (<profiles-list mode={mode} />);
    }

    renderSearch = () => {
        return (
            <row className='is-justified-center'>
                <column className='is-6 is-12-mobile'>
                    <input
                        type='search'
                        name='profile_search'
                        placeholder='Search Name'
                        value={this.state.filter}
                        onInput={this.filterProfiles}
                    />
                </column>
            </row>
        );
    }

    renderProfiles = () => {
        let filteredProfiles = _.filter(this.props.profiles, (profile, i) => {
            return i > 0;
        });

        if (this.state.filter) {
            filteredProfiles = _.filter(filteredProfiles, (profile) => {
                return profile.first_name.toLowerCase().includes(this.state.filter.toLowerCase());
            });
        }

        if (filteredProfiles.length) {
            return [
                _.sortBy(filteredProfiles, 'first_name').map(this.renderProfile),
                this.renderMore(filteredProfiles),
            ];
        }

        return (<h4 className='has-text-center'>No Profiles Found</h4>);
    }

    renderProfile = (profile) => {
        const birth_date = dayjs(profile.birth_date, 'YYYY-MM-DD');
        const birth_time = dayjs(profile.birth_time, 'HH:mm');

        return (
            <row className='is-justified-center is-aligned-center has-margin-15-bottom'>
                <column className='is-1 is-2-mobile has-text-center'>
                    <RadioGroup
                        name='profile'
                        value={profile.profile_id}
                        checked={this.props.profile && this.props.profile.profile_id == profile.profile_id}
                        onClick={(e) => this.selectProfile(e, profile)}
                    />
                </column>
                <column className='is-9 is-7-mobile'>
                    <row className='is-wrap is-aligned-center'>
                        <column className='is-5 is-12-mobile'>
                            <h5 onClick={(e) => this.selectProfile(e, profile)}>
                                {profile.first_name}
                            </h5>
                        </column>
                        <column className='is-7 is-12-mobile'>
                            <label onClick={(e) => this.selectProfile(e, profile)}>
                                {this.renderBirthDateTime(birth_date, birth_time)}
                                {this.renderBirthLocation(profile)}
                            </label>
                        </column>
                    </row>
                </column>
                {this.renderIcons(profile)}
            </row>
        );
    }

    renderBirthDateTime = (date, time) => {
        if (date.isValid() && time.isValid()) {
            return (<span>{date.format('MMMM D, YYYY')} {time.format('h:mma')}<br /></span>);
        } else if (date.isValid()) {
            return (<span>{date.format('MMMM D, YYYY')}<br /></span>);
        } else if (time.isValid()) {
            return (<span>{time.format('h:mma')}<br /></span>);
        }

        return null;
    }

    renderBirthLocation = (profile) => {
        if (profile.birth_city && profile.birth_state && profile.birth_country) {
            return (<span>{profile.birth_city}, {profile.birth_state} {profile.birth_country}</span>);
        }

        return null;
    }

    renderIcons = (profile) => {
        if (this.props.mode == 'full') {
            return (
                <column className='is-2 is-3-mobile'>
                    <row className='is-wrap'>
                        <column className='is-6 is-12-mobile has-text-center'>
                            <a href='#' onClick={(e) => this.selectProfile(e, profile)}>
                                <img
                                    src='https://gfx.tarot.com/images/product/new-profiles-manager/pencil.svg'
                                    alt='edit'
                                />
                            </a>
                        </column>
                        <column className='is-6 is-12-mobile has-text-center'>
                            <a href='#' onClick={(e) => this.deleteProfile(e, profile)}>
                                <img
                                    src='https://gfx.tarot.com/images/product/new-profiles-manager/trash.svg'
                                    alt='delete'
                                />
                            </a>
                        </column>
                    </row>
                </column>
            );
        }

        return null;
    }

    renderMore = (filteredProfiles) => {
        if (filteredProfiles.length > 2) {
            return (<div className='more' />);
        }

        return null;
    }

    filterProfiles = (e) => {
        if (this.props.profile) {
            this.props.userUpdate({ selected_profile: null });
        }

        this.setState({ filter: e.target.value });
    }

    selectProfile = (e, profile) => {
        e.preventDefault();

        if (profile.profile_id != this.props.profile) {
            this.props.userUpdate({ selected_profile: profile });
        }
    }

    deleteProfile = (e, profile) => {
        e.preventDefault();

        /* eslint-disable max-len */
        this.props.userUpdate({
            profileModal: {
                profile: profile,
                message: 'Are you sure you want to<br class="is-visible-mobile" /><span class="is-hidden-mobile"> </span>delete your friend profile?',
                buttonText: 'DELETE',
                linkText: 'Back to what I was doing',
                type: 'delete',
            },
        });
        /* eslint-enable max-len */

        this.props.routeTo('profile');
    }
}

const mapStateToProps = (state) => ({
    profiles: state.user && state.user.profiles,
    profile: state.user && state.user.selected_profile,
    tab: state.user && state.user.tab,
    logged_in: state.user && state.user.logged_in,
    submitting: state.product && state.product.submitting,
});

const mapDispatchToProps = (dispatch) => ({
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
